const productData = [
  {
    id: 1,
    image: require("@/assets/images/product/img-1.png"),
    discount: 20,
    brand: "Nike",
    name: "Nike N012 Shoes",
    disc: "Gray, Shoes",
    oldprice: 280,
    newprice: 260,
    colors: ["dark", "light", "primary"],
    specification: [
      "High Quality",
      "Leather",
      "All Sizes available",
      "3 Different Color"
    ],
    services: ["10 Days Replacement", "Cash on Delivery available"]
  },
  {
    id: 2,
    image: require("@/assets/images/product/img-2.png"),
    discount: 10,
    brand: "Adidas",
    name: "Adidas Running Shoes",
    disc: "Black, Shoes",
    oldprice: 250,
    newprice: 240,
    colors: ["danger", "dark", "light"],
    specification: [
      "High Quality",
      "Leather",
      "All Sizes available",
      "3 Different Color"
    ],
    services: ["10 Days Replacement", "Cash on Delivery available"]
  },
  {
    id: 3,
    image: require("@/assets/images/product/img-3.png"),
    discount: 10,
    brand: "Puma",
    name: "Puma P103 Shoes",
    disc: "Purple, Shoes",
    oldprice: 260,
    newprice: 250,
    colors: ["purple", "light", "dark"],
    specification: [
      "High Quality",
      "Leather",
      "All Sizes available",
      "3 Different Color"
    ],
    services: ["10 Days Replacement", "Cash on Delivery available"]
  },
  {
    id: 4,
    image: require("@/assets/images/product/img-4.png"),
    discount: 10,
    brand: "",
    name: "Sports S120 Shoes",
    disc: "Purple, Shoes",
    oldprice: 240,
    newprice: 230,
    colors: ["info", "success"],
    specification: [
      "High Quality",
      "Leather",
      "All Sizes available",
      "3 Different Color"
    ],
    services: ["10 Days Replacement", "Cash on Delivery available"]
  },
  {
    id: 5,
    image: require("@/assets/images/product/img-5.png"),
    discount: 10,
    brand: "Adidas",
    name: "Adidas AB23 Shoes",
    disc: "Blue, Shoes",
    oldprice: 250,
    newprice: 240,
    colors: ["dark", "light", "primary"],
    specification: [
      "High Quality",
      "Leather",
      "All Sizes available",
      "3 Different Color"
    ],
    services: ["10 Days Replacement", "Cash on Delivery available"]
  },
  {
    id: 6,
    image: require("@/assets/images/product/img-6.png"),
    discount: 10,
    brand: "Nike",
    name: "Nike N012 Shoes",
    disc: "Gray, Shoes",
    oldprice: 270,
    newprice: 260,
    colors: ["dark", "light"],
    specification: [
      "High Quality",
      "Leather",
      "All Sizes available",
      "3 Different Color"
    ],
    services: ["10 Days Replacement", "Cash on Delivery available"]
  }
];

export { productData };
